// extracted by mini-css-extract-plugin
export default {"errorCell":"columns_errorCell__N6Ld3","warningCell":"columns_warningCell__ophlE"};